module.exports = __webpack_public_path__ + "img/9788994475813.7516f5c9.jpg";